var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show-menu[data-v-3ece14fc]{position:absolute;top:40px;left:40px;z-index:100}.background[data-v-3ece14fc]{background:url(" + escape(require("@/assets/images/background.jpg")) + ");background-size:cover;background-position:50%}.content[data-v-3ece14fc]{display:flex;justify-content:center;align-items:center}.home-frame[data-v-3ece14fc]{position:relative;width:1920px;height:1080px}.home-contents[data-v-3ece14fc]{position:absolute;top:81px;left:658px;width:1180px;height:720px;background:hsla(0,0%,100%,.2)}.home-carousel[data-v-3ece14fc]{width:1180px}.home-carousel[data-v-3ece14fc],.link-to-home[data-v-3ece14fc]{position:absolute;top:866px;left:658px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ece14fc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/index.vue
// module id = 562
// module chunks = 0